import classNames from 'classnames';
import { IconNameV2 } from 'common/icon/iconV2';
import { MouseEventHandler } from 'react';
import { FlexDivCenteredIcon } from 'utilities/svg-display/svg-layout';

export type TooltipPlacement = 'top' | 'bottom' | 'left' | 'right';
export type MapButtonVariant = 'top' | 'center' | 'bottom' | 'isolated';

const variantRadiusClass: Record<MapButtonVariant, string> = {
  top: 'border-radius-xs--top',
  center: '',
  bottom: 'border-radius-xs--bottom',
  isolated: 'border-radius-xs',
};

export type MapButtonProps = {
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  iconName: IconNameV2;
  variant: MapButtonVariant;
  classes?: string;
  testId?: string;
  title?: string;
  tooltipPlacement?: TooltipPlacement;
};

export const MapButton = ({ onClick, iconName, variant, classes, testId, title, tooltipPlacement = 'left' }: MapButtonProps) => {
  return (
    <button
      className={classNames(
        'ZoomControl-btn u-flexAlignItemsCenter zoom u-flex u-flexJustifyCenter',
        { 'is-disabled': !onClick },
        variantRadiusClass[variant],
        title && 'has-tooltip',
        title && `tooltip--${tooltipPlacement}`,
        classes,
      )}
      onClick={onClick}
      disabled={!onClick}
      data-testid={testId}
      title={title}
      role="button"
    >
      <div className="u-flex-1">
        <FlexDivCenteredIcon v={2} icon={iconName} size={16} classes={`svg--fill-inherit`} />
      </div>
    </button>
  );
};
